import { useState } from "react";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import profileImage from "../../Assets/Misc/profile-pic-alban_bujupaj.webp";

import TopLeftSVG from "./TopLeftSVG";

import "./AboutSection.scss";

gsap.registerPlugin(ScrollTrigger);

const AboutSection = () => {
  const [title] = useState("About");

  return (
    <div className="about-section">
      <TopLeftSVG />
      <div className="about-section-content">
        <h1>
          {title.split("").map((char, index) => (
            <span key={index}>{char}</span>
          ))}{" "}
          <span className="watermark">
            {title.split("").map((char, index) => (
              <span key={index}>{char}</span>
            ))}
          </span>
        </h1>

        <div className="description-holder">
          <div className="description-inner">
            <p className="description">
              <span>
                Hi 👋 ― I am Alban
                <span className="avatar">
                  <img src={profileImage} alt="Alban Bujupaj" />
                </span>
                an experienced <b>Frontend Developer</b> and{" "}
                <b>product crafter</b> with over 9 years of professional
                expertise. <br /> My comprehensive grasp of technology empowers
                me to craft compelling frontend applications that seamlessly
                integrate graphic arts, translating brand elements into polished
                web experiences.
              </span>

              <span>
                Specializing in React, Typescript, Javascript (ES6+), Redux,
                Stylus, SCSS/CSS3, RESTAPI, GraphQL, and various libraries and
                tools, I am dedicated to writing elegant and clean code. My
                approach involves creating reusable components, meticulous
                attention to code details, and a focus on high-performance web
                applications that deliver impeccable results.
              </span>
              <span>
                Beyond frontend development, I extend my skills to create visual
                identities and user experience systems for diverse clients in
                cultural, commercial, and editorial domains.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
